export const DVTJCUVSearchCddJobSetReceiverListTabs = {
    RECEIVERS_AUTO_RELEASED_TAB: {title: '1.1-Receivers AUTO Released', id: 'dvtjcuv-search-cdd-job-receivers_auto_released-tab'},
    RECEIVERS_MANUALLY_RELEASED_TAB: {title: '1.2-Receivers MANUALLY Released', id: 'dvtjcuv-search-cdd-job-receivers_manually_released-tab'},
    RECEIVERS_SENT_TAB: {title: '1.3-Receivers SENT', id: 'dvtjcuv-search-cdd-job-receivers_sent-tab'},
};

export const DVTJCUVSearchCddJobSendEmailBriefUVTabs = {
    DRAFT_TAB: {title: '2.1-Duyệt Draft & Gửi email', id: 'brief-email-draft-tab'},
    NOT_PERMISSION_EMAIL_TAB: {title: '2.2-Receiver bạn chưa có quyền gửi email', id: 'brief-email-not-permission-email-tab'},
    NEED_CHECKING_TAB: {title: '2.3-Receiver need checking', id: 'brief-email-need-checking-tab'},
    NEED_INPUT_INFO_TAB: {title: '2.4-Receiver cần nhập bổ sung ttin', id: 'brief-email-need-input-info-tab'},
    WAITING_SEND_BY_WEEK_TAB: {title: '2.5-Receiver chờ gửi theo tuần', id: 'brief-email-waiting-send-by-week-tab'},
    WAITING_SEND_BY_MONTH_TAB: {title: '2.6-Receiver chờ gửi theo tháng', id: 'brief-email-waiting-send-by-month-tab'},
    SEND_WHEN_UNLIMITED_TAB: {title: '2.7-Receiver chờ hạn mức', id: 'brief-email-send-when-unlimited-tab'},
    EXPORTED_WAITING_SEND_EMAIL_BRIEF_UV_TAB: {title: '2.8- Receiver đã export', id: 'brief-email-exported-waiting-send-uv-tab'}
};

export const DVTJCUVSearchCddJobHaveJobTabs = {
    OFFERING_TAB: {title: '4.1-Offering', id: 'offering-tab'},
    INTERVIEWING_TAB: {title: '4.2-Interviewing', id: 'interviewing-tab'},
    CV_SENT_TAB: {title: '4.3-CV sent', id: 'cv-sent-tab'},
    EMP_SHARED_JOB_TAB: {title: '4.4-Emp shared job', id: 'emp-shared-job-tab'}
};

export const DVTJCUVSearchCddJobParentTabs = {
    SET_RECEIVER_LIST_TAB: {title: '1-Set list Receivers', id: 'dvtjcuv-search-cdd-job-set-receiver-list-tab', childTabs: DVTJCUVSearchCddJobSetReceiverListTabs},
    SEND_EMAIL_BRIEF_UV_TAB: {title: '2-Gửi Email Brief UV', id: 'dvtjcuv-search-cdd-job-send-email-brief-uv-tab', childTabs: DVTJCUVSearchCddJobSendEmailBriefUVTabs},
    PROCESS_FEEDBACK_TAB: {title: '3-Xử lý phản hồi', id: 'dvtjcuv-search-cdd-job-process-feedback-tab', childTabs: {}},
    HAVE_JOB_TAB: {title: '4-Có job', id: 'dvtjcuv-search-cdd-job-has-job-tab', childTabs: DVTJCUVSearchCddJobHaveJobTabs},
    EMP_CARE_BRIEF_UV_TAB: {title: '5-Emp quan tâm Brief UV', id: 'dvtjcuv-search-cdd-job-emp-care-brief-uv-tab', childTabs: {}},
    NEED_FU_TAB: {title: '6-Cần FU', id: 'dvtjcuv-search-cdd-job-need-fu-tab', childTabs: {}},
    NEED_REP_TAB: {title: '7-Cần Rep', id: 'dvtjcuv-search-cdd-job-need-rep-tab', childTabs: {}},
    PAYMENT_AND_WARRANTY_TAB: {title: '8-TT&BH', id: 'dvtjcuv-search-cdd-payment-and-warranty-tab', childTabs: {}},
    PROCESS_ENDED_TAB: {title: '9-Process Ended', id: 'dvtjcuv-search-cdd-process-ended-tab', childTabs: {}},
};
